@let accepted = accepted$ | async;

<button
  id="px-bot-launcher"
  type="button"
  [aria-label]="
    (accepted ? 'Ouvrir le chatbot Mavic' : 'Pour discuter avec Mavia, acceptez les cookies')
      | translate
      | async
  "
  [attr.aria-expanded]="accepted ? open : null"
  [attr.aria-controls]="accepted ? 'px-chat-panel' : null"
  [class.pulse]="pulsing"
  (click)="toggle(accepted); $event.stopPropagation()"
>
  <svg class="px-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M4 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H8l-4 4V5z"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linejoin="round"
    />
    <circle cx="9" cy="10" r="1.2" fill="currentColor" />
    <circle cx="12" cy="10" r="1.2" fill="currentColor" />
    <circle cx="15" cy="10" r="1.2" fill="currentColor" />
  </svg>
  @if (accepted) {
    {{ 'Discuter avec Mavia' | translate | async }}
  } @else {
    <span class="px-label">
      <span>{{ 'Pour discuter avec Mavia' | translate | async }}</span>
      <span class="px-label-accept">{{ 'Acceptez les cookies' | translate | async }}</span>
    </span>
  }
</button>

<section
  #panel
  id="px-chat-panel"
  [class.open]="open"
  role="dialog"
  [aria-label]="'Discuter avec Mavia'| translate | async"
  [attr.aria-hidden]="!open"
>
  <button
    #closeBtn
    id="px-chat-close"
    type="button"
    [aria-label]="'Fermer le chat'| translate | async"
    (click)="close(); $event.stopPropagation()"
  >
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
      <path
        d="M6 6l12 12M18 6L6 18"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  </button>
  <!-- Deployment div, id provided by Mavic Quest — do not change -->
  <div #deploy class="px-deployment" [id]="'deployment-' + deploymentId"></div>
</section>
